import { TooltipProvider } from '@monksflow/monks-ui';
import { Maximize2Icon, Minimize2Icon } from 'lucide-react';
import { useAnnotationFullscreen } from '@/features/comment-on-file';
import { ZoomButton } from '../ZoomControls/ZoomButton';
import { useTranslation } from 'react-i18next';

/**
 * Single fullscreen-toggle button. Renders bare — the caller owns the
 * surrounding `ControlGroup` pill, so it composes alongside the zoom / page
 * controls in one shared pill. Mirrors the `ZoomButton` styling so it reads
 * as a sibling control. The exit-fullscreen affordance lives in the
 * FullscreenTopBar's close button — this toggle stays hidden while
 * fullscreen is active because each overlay gates its `HoverControlsPill`
 * on `!isFullscreen`.
 */
export function FullscreenToggle() {
  const { t } = useTranslation('projects');

  const { isFullscreen, toggleFullscreen } = useAnnotationFullscreen();
  return (
    <TooltipProvider delayDuration={300}>
      <div className="flex items-center px-2 py-2">
        <ZoomButton
          label={
            isFullscreen
              ? t('projectDetail.fullscreenToggle.exitFullscreen')
              : t('projectDetail.fullscreenToggle.expand')
          }
          Icon={isFullscreen ? Minimize2Icon : Maximize2Icon}
          disabled={false}
          onClick={toggleFullscreen}
        />
      </div>
    </TooltipProvider>
  );
}
